import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import { DownloadSimple, FolderOpen, Eye, Copy } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const History = () => {
  const [deployments, setDeployments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const res = await axios.get(`/api/deployments`, { withCredentials: true });
      setDeployments(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleDownload = async (id) => {
    try {
      const res = await axios.get(`/api/deployments/${id}/download`, { withCredentials: true });
      window.open(res.data.download_url, '_blank');
    } catch (e) {
      toast.error(e.response?.data?.detail || "Archive not found or failed to generate link");
    }
  };

  return (
    <div className="space-y-8">
      <h1 className="text-4xl font-black">DEPLOYMENT HISTORY</h1>
      
      <div className="border border-white/10 bg-card overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-white/10 bg-black/20">
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Date</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Bucket</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Account (DC)</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">File</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Status</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">URL</th>
            </tr>
          </thead>
          <tbody>
            {deployments.map(dep => (
              <tr key={dep.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                <td className="p-4 text-sm text-slate-400 font-mono">{format(new Date(dep.created_at), 'yyyy-MM-dd HH:mm')}</td>
                <td className="p-4 font-mono text-sm">
                  {dep.bucket_name}
                  {dep.status === 'live' && (
                    <button 
                      onClick={() => navigate(`/do/deployments/${dep.id}/manager`)}
                      className="ml-3 text-xs bg-white/10 hover:bg-primary hover:text-black transition-colors px-2 py-1 font-bold inline-flex items-center gap-1"
                      title="File Manager"
                    >
                      <FolderOpen size={14} /> MGR
                    </button>
                  )}
                </td>
                <td className="p-4 text-sm">{dep.account_label} <span className="text-slate-500 uppercase">({dep.datacenter})</span></td>
                <td className="p-4 text-sm text-slate-400 font-mono flex items-center gap-3">
                  <span className="truncate max-w-[150px] inline-block" title={dep.original_zip_name}>{dep.original_zip_name}</span>
                  {dep.status === 'live' && (
                    <button 
                      onClick={() => handleDownload(dep.id)} 
                      className="text-primary hover:text-white transition-colors" 
                      title="Download Original Zip"
                    >
                      <DownloadSimple size={16} />
                    </button>
                  )}
                </td>
                <td className="p-4 text-sm">
                  <span className={`px-2 py-1 text-xs font-bold tracking-wider ${
                    dep.status === 'live' ? 'bg-[#39FF14]/10 text-[#39FF14] border border-[#39FF14]/20' : 
                    dep.status === 'failed' ? 'bg-red-500/10 text-red-500 border border-red-500/20' : 
                    'bg-yellow-500/10 text-yellow-500 border border-yellow-500/20'
                  }`}>
                    {dep.status}
                  </span>
                </td>
                <td className="p-4 text-sm">
                  {dep.public_url ? (() => {
                    let finalUrl = dep.public_url;
                    if (!finalUrl.startsWith('http')) finalUrl = 'https://' + finalUrl;
                    finalUrl = finalUrl.endsWith('/') ? finalUrl + 'index.html' : (finalUrl.endsWith('/index.html') ? finalUrl : finalUrl + '/index.html');
                    return (
                      <div className="flex items-center gap-2">
                        <div className="bg-[#0A0B0E] border border-white/10 px-2 py-1 text-xs text-slate-400 font-mono truncate w-48 select-all" title={finalUrl}>
                          {finalUrl}
                        </div>
                        <button 
                          onClick={() => { navigator.clipboard.writeText(finalUrl); toast.success("Copied!"); }}
                          className="text-slate-400 hover:text-white transition-colors p-1"
                          title="Copy URL"
                        >
                          <Copy size={16} />
                        </button>
                        <a 
                          href={finalUrl} 
                          target="_blank" 
                          rel="noreferrer" 
                          className="text-slate-400 hover:text-primary transition-colors p-1"
                          title="Preview Site"
                        >
                          <Eye size={16} />
                        </a>
                      </div>
                    );
                  })() : '-'}
                </td>
              </tr>
            ))}
            {deployments.length === 0 && (
              <tr>
                <td colSpan="6" className="p-8 text-center text-slate-500">No deployment history.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default History;